import { concat, forkJoin, of, throwError } from 'rxjs';
import { mergeMap, take, map, takeUntil, catchError } from 'rxjs/operators';
import { IEpic, isTypeOf, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { interpolateErrorParams } from '@cbridge-utils/formatters';
import { SymbolGroupsAction } from '@cbridge-packages/symbol-groups';
import { SymbolAssetsAction } from '@cbridge-packages/symbol-assets';
import { SymbolAction } from '@cbridge-packages/symbol';
import { InfinityDataGridAction } from '@cbridge-modules/infinity-data-grid';

export const reloadSymbolListEpic: IEpic = (action$) =>
  action$.pipe(
    isTypeOf(
      SymbolAction.reload,
      SymbolAction.create.done,
      SymbolAction.update.done,
      SymbolAction.remove.done,
      SymbolAction.bulkUpdate.done,
      SymbolAction.bulkRemove.done,
    ),
    mergeMap(() => {
      const waitAssets$ = action$.pipe(
        isTypeOfAndGetPayload(SymbolAssetsAction.load.done),
        take(1),
        takeUntil(
          action$.pipe(
            isTypeOfAndGetPayload(SymbolAssetsAction.load.failed),
            mergeMap(({ error }) => throwError(() => new Error(`${error.errorCode} - ${interpolateErrorParams(error.description ?? '', error.params)}`))),
          ),
        ),
      );

      const waitGroups$ = action$.pipe(
        isTypeOfAndGetPayload(SymbolGroupsAction.load.done),
        take(1),
        takeUntil(
          action$.pipe(
            isTypeOfAndGetPayload(SymbolGroupsAction.load.failed),
            mergeMap(({ error }) => throwError(() => new Error(`${error.errorCode} - ${interpolateErrorParams(error.description ?? '', error.params)}`))),
          ),
        ),
      );

      return concat(
        of(SymbolAssetsAction.load.started({})),
        of(SymbolGroupsAction.load.started()),
        forkJoin([waitAssets$, waitGroups$]).pipe(
          map(() => {
            return InfinityDataGridAction.refreshData();
          }),
          catchError(() => of({ type: '@@CBRIDGE/NOOP' })), // safe action type
        ),
      );
    }),
  );
